import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { ConnectedAgreementLinks } from './ConnectedAgreementLinks/ConnectedAgreementLinks';
export const GetConnectedAgreementsTID = (parentTestId)=>getTestIds(parentTestId);
export const ConnectedAgreements = (param)=>{
    let { agreements, testId } = param;
    const { ConnectedAgreementsTestIds: TID } = useMemo(()=>GetConnectedAgreementsTID(testId), [
        testId
    ]);
    const { t: texts } = useLocaleKeys('client.detail.summary.paymentMethods');
    return /*#__PURE__*/ _jsx(Typography, {
        testId: TID.Root(),
        variant: "paragraph3",
        weight: "light",
        skin: "secondary",
        children: agreements.length > 0 ? texts.connectedTo({
            agreements: /*#__PURE__*/ _jsx(ConnectedAgreementLinks, {
                agreements: agreements
            })
        }) : texts.notConnected()
    });
};
